<app-split [id]="splitComponentId">
  <div class="legalizations-list container">
    <div class="content">
      <div class="content-card filters">
        <div class="top">
          <div class="top__right">
            <button (click)="resetFilters()" class="top__button top__button-clear">
              <mat-icon>close</mat-icon>
              {{ 'Reset' | translate }}
            </button>
            <button
              (click)="toggleFiltersPanel()"
              class="top__button top__button-filter"
              [matBadge]="filters.length"
              [matBadgeHidden]="!filters.length"
              >
              <mat-icon>filter_alt</mat-icon>
              {{ 'Filter' | translate }}
            </button>
          </div>
        </div>
        @if (areFiltersExpanded) {
          <app-list-filter></app-list-filter>
        }
      </div>

      <div class="content-card" [ngClass]="{ 'filters-opened': areFiltersExpanded }">
        <div #tableContainer class="wrapper custom-table">
          <div class="table-scroll-container">
            <cdk-virtual-scroll-viewport gridTableVirtualScroll (scrolledIndexChange)="nextBatch($event)">
              <mat-table #table [dataSource]="dataSource" [trackBy]="trackBy" multiTemplateDataRows>
                <!-- LastName Column -->
                <ng-container matColumnDef="lastName">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.LastName' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    @if (isFirstOccurrence(element)) {
                      <span [matTooltip]="element.LastName" class="first-occurrence-data">{{
                        element.LastName
                      }}</span>
                    }
                  </mat-cell>
                </ng-container>
                <!-- FirstName Column -->
                <ng-container matColumnDef="firstName">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.FirstName' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    @if (isFirstOccurrence(element)) {
                      <span [matTooltip]="element.FirstName" class="first-occurrence-data">{{
                        element.FirstName
                      }}</span>
                    }
                  </mat-cell>
                </ng-container>
                <!-- StartDate Column -->
                <ng-container matColumnDef="startDate">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.StartDate' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    @if (isFirstOccurrence(element)) {
                      <span class="first-occurrence-data">
                        {{ element.StartDate | date : 'dd.MM.yyyy' }}
                      </span>
                    }
                  </mat-cell>
                </ng-container>
                <!-- EndDate Column -->
                <ng-container matColumnDef="endDate">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.EndDate' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    @if (isFirstOccurrence(element)) {
                      <span class="first-occurrence-data">
                        {{ element.EndDate | date : 'dd.MM.yyyy' }}
                      </span>
                    }
                  </mat-cell>
                </ng-container>
                <!-- StatusName Column -->
                <ng-container matColumnDef="statusName">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.StatusName' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    @if (isFirstOccurrence(element)) {
                      <span>
                        <span class="status-label first-occurrence-data" [ngClass]="getStatusClass(element.LegalizationStatusId)">
                          {{ element.LegalizationStatusName }}
                        </span>
                      </span>
                    }
                  </mat-cell>
                </ng-container>

                <!-- Expand Column -->
                <ng-container matColumnDef="expandingIcon">
                  <mat-header-cell *matHeaderCellDef class="expand-header"></mat-header-cell>
                  <mat-cell
                    [class.clickable]="element.DocumentId && element.CorrectedDocuments?.length > 0"
                    class="expand-cell"
                    *matCellDef="let element"
                    (click)="element.DocumentId && element.CorrectedDocuments?.length > 0 && expandDocument(element.DocumentId)"
                    [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === element.DocumentId"
                    >
                    @if (element.DocumentId && element.CorrectedDocuments?.length > 0) {
                      <mat-icon>
                        {{ expandedElementDocumentId !== element.DocumentId ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                      </mat-icon>
                    }
                  </mat-cell>
                </ng-container>

                <!-- Details Column -->
                <ng-container matColumnDef="details">
                  <mat-header-cell *matHeaderCellDef> {{ registerPrefix + '.Details' | translate }} </mat-header-cell>
                  <mat-cell
                    [matTooltip]="registerPrefix + '.DocumentDetails' | translate"
                    *matCellDef="let element"
                    [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === element.DocumentId"
                    >
                    <button mat-icon-button (click)="showDetails(element.LegalizationId, element.DocumentId)">
                      <mat-icon class="material-icons-outlined">read_more</mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>

                <!-- DocumentTypeName Column -->
                <ng-container matColumnDef="documentTypeName">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.DocumentType' | translate }}
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    [matTooltip]="element.DocumentTypeName"
                    [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === element.DocumentId"
                    >
                    {{ element.DocumentTypeName }}
                  </mat-cell>
                </ng-container>

                <!-- DocumentStartDate Column -->
                <ng-container matColumnDef="documentStartDate">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.DocumentStartDate' | translate }}
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === element.DocumentId"
                    >
                    {{ element.DocumentStartDate | date : 'dd.MM.yyyy' }}
                  </mat-cell>
                </ng-container>

                <!-- DocumentEndDate Column -->
                <ng-container matColumnDef="documentEndDate">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.DocumentEndDate' | translate }}
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === element.DocumentId"
                    >
                    {{ element.DocumentEndDate | date : 'dd.MM.yyyy' }}
                  </mat-cell>
                </ng-container>

                <!-- DocumentStatusName Column -->
                <ng-container matColumnDef="documentStatusName">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.DocumentStatusName' | translate }}
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === element.DocumentId"
                    >
                    <span class="status-label" [ngClass]="getDocumentStatusClass(element.DocumentStatusId)">
                      {{ element.DocumentStatusName }}
                    </span>
                  </mat-cell>
                </ng-container>
                <!-- Alert Column -->
                <ng-container matColumnDef="alert">
                  <mat-header-cell *matHeaderCellDef>
                    {{ registerPrefix + '.Alert' | translate }}
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === element.DocumentId"
                    >
                    @if (element.DocumentAlertStatusId && element.DocumentAlertStatusId != legalizationAlertStatusEnum.NoAlert) {
                      <span
                        class="status-label"
                        [ngClass]="getAlertStatusClass(element.DocumentAlertStatusId)"
                        >
                        {{ element.DocumentAlertStatusName }}
                      </span>
                    }
                  </mat-cell>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions" stickyEnd>
                  <mat-header-cell *matHeaderCellDef sticky>{{ 'DeclarationsList.Actions' | translate }}</mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    sticky
                    [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === element.DocumentId"
                    >
                    @if (screenService.isAboveMd$ | async) {
                      <button mat-icon-button [matMenuTriggerFor]="menuRow">
                        <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                      </button>
                    } @else {
                      <button mat-icon-button [matMenuTriggerFor]="menuRow">
                        <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                      </button>
                    }

                    <mat-menu #menuRow="matMenu" panelClass="actions-menu">
                      @if (existsDocumentButtonVisible(element)) {
                        <button mat-button (click)="openLegalizationFilesModal(element.Files, element.WorkerId, element.DocumentTypeName)">
                          <mat-icon class="material-icons-outlined">folder_open</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.ShowFiles' | translate }}</span>
                        </button>
                      }
                      @if (!existsDocumentButtonVisible(element)) {
                        <button
                          [visibleWithPermissions]="['AddLegalizationDocument']"
                          mat-button
                          (click)="openDocumentLegalizationForCoordinator(element.WorkerId, element.FirstName, element.LastName)"
                          >
                          <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.AddDocument' | translate }}</span>
                        </button>
                      }
                      <ng-container>
                        <button
                          [visibleWithPermissions]="['LegalizationDecision']"
                          mat-button
                          (click)="openDocumentLegalizationForLegalizer(element)"
                          >
                          <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                          <span class="button-text">{{ addOrCorrectLabel(element) }}</span>
                        </button>
                      </ng-container>
                      @if (existsDocumentButtonVisible(element)) {
                        <button [visibleWithPermissions]="['EditLegalizationDocument']" mat-button (click)="editDocument(element.DocumentId)">
                          <mat-icon class="material-icons-outlined">edit</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.EditDocument' | translate }}</span>
                        </button>
                      }
                      @if (existsDocumentButtonVisible(element)) {
                        <button
                          [visibleWithPermissions]="['AssignLegalizationDocument']"
                          mat-button
                          (click)="openAssigningDocuments(element.WorkerId, element.FirstName, element.LastName, element.DocumentId)"
                          >
                          <mat-icon class="material-icons-outlined">call_split</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.AssignDocument' | translate }}</span>
                        </button>
                      }
                      <ng-container>
                        <button mat-button [routerLink]="['/profile/' + element.WorkerId + '/documents']">
                          <mat-icon class="material-icons-outlined">person</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.ShowWorkerProfile' | translate }}</span>
                        </button>
                      </ng-container>
                    </mat-menu>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="progress">
                  <mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                    <mat-progress-bar [mode]="dataSource.isLoading ? 'indeterminate' : 'determinate'" class="table-progress" color="accent">
                    </mat-progress-bar>
                  </mat-header-cell>
                </ng-container>

                <!-- Expanded Content Column - Shows document details -->
                <ng-container matColumnDef="expandedDetail">
                  <mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="expanded-element-detail" [@detailExpand]="element.DocumentId == expandedElementDocumentId ? 'expanded' : 'collapsed'">
                      <div class="corrected-documents-container">
                        <mat-table #correctedTable [dataSource]="element.CorrectedDocuments || []" class="secondary-table">
                          <ng-container matColumnDef="expandingIcon">
                            <mat-cell
                              *matCellDef="let document"
                              [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === document.DocumentId"
                              >
                              <span class="child-row-indicator">•</span>
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="details">
                            <mat-cell
                              *matCellDef="let document"
                              [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === document.DocumentId"
                              >
                              <button mat-icon-button (click)="showDetails(element.LegalizationId, document.DocumentId)">
                                <mat-icon class="material-icons-outlined">read_more</mat-icon>
                              </button>
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="documentTypeName">
                            <mat-cell
                              *matCellDef="let document"
                              [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === document.DocumentId"
                              >
                              {{ document.DocumentTypeName }}
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="documentStartDate">
                            <mat-cell
                              *matCellDef="let document"
                              [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === document.DocumentId"
                              >
                              {{ document.DocumentStartDate | date : 'dd.MM.yyyy' }}
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="documentEndDate">
                            <mat-cell
                              *matCellDef="let document"
                              [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === document.DocumentId"
                              >
                              {{ document.DocumentEndDate | date : 'dd.MM.yyyy' }}
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="documentStatusName">
                            <mat-cell
                              *matCellDef="let document"
                              [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === document.DocumentId"
                              >
                              <span class="status-label" [ngClass]="getDocumentStatusClass(document.DocumentStatusId)">
                                {{ document.DocumentStatusName }}
                              </span>
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="alert">
                            <mat-cell
                              *matCellDef="let document"
                              [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === document.DocumentId"
                              >
                              @if (document.DocumentAlertStatusId) {
                                <span
                                  class="status-label"
                                  [ngClass]="getAlertStatusClass(document.DocumentAlertStatusId)"
                                  >
                                  {{ document.DocumentAlertStatusName }}
                                </span>
                              }
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="actions" stickyEnd>
                            <mat-cell
                              *matCellDef="let document"
                              sticky
                              [class.active-row]="activeLegalizationId === element.LegalizationId && activeDocumentId === document.DocumentId"
                              >
                              <button mat-icon-button [matMenuTriggerFor]="menuDocument">
                                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                              </button>
                              <mat-menu #menuDocument="matMenu" panelClass="actions-menu">
                                <button mat-button (click)="openLegalizationFilesModal(document.Files, element.WorkerId, element.DocumentTypeName)">
                                  <mat-icon class="material-icons-outlined">folder_open</mat-icon>
                                  <span class="button-text">{{ registerPrefix + '.ShowFiles' | translate }}</span>
                                </button>
                              </mat-menu>
                            </mat-cell>
                          </ng-container>

                          <mat-row *matRowDef="let row; columns: displayedExpandedColumns"></mat-row>
                        </mat-table>
                      </div>
                    </div>
                  </mat-cell>
                </ng-container>

                <!-- Section headers -->
                <ng-container matColumnDef="legalizationHeader">
                  <mat-header-cell *matHeaderCellDef [attr.colspan]="5" class="section-header">
                    {{ registerPrefix + '.LegalizationsProcesses' | translate }}
                  </mat-header-cell>
                </ng-container>

                <ng-container matColumnDef="documentsHeader">
                  <mat-header-cell *matHeaderCellDef [attr.colspan]="7" class="section-header">
                    {{ registerPrefix + '.Documents' | translate }}
                  </mat-header-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="['legalizationHeader', 'documentsHeader']; sticky: true"
                  class="section-header-row"
                  [style.top.px]="offset$ | async"
                ></mat-header-row>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" [style.top.px]="(offset$ | async) + 48"></mat-header-row>
                <mat-header-row
                  *matHeaderRowDef="['progress']; sticky: true"
                  class="progress"
                  [style.top.px]="(offset$ | async) + 104"
                ></mat-header-row>

                <!-- Regular data rows -->
                <mat-row
                  *matRowDef="let row; columns: displayedColumns"
                  [class.first-occurrence]="isFirstOccurrence(row)"
                  [class.last-occurrence]="isLastOccurrence(row)"
                  [class.legalization-odd]="isOddLegalization(row)"
                  [class.legalization-even]="isEvenLegalization(row)"
                  [class.expanded-expanded-row]="expandedElementDocumentId === row.DocumentId"
                ></mat-row>

                <!-- Expanded detail rows -->
                <mat-row
                  [@rowExpand]="row.DocumentId == expandedElementDocumentId ? 'expanded' : 'collapsed'"
                  *matRowDef="let row; columns: ['expandedDetail']; when: hasCorrectedDocuments"
                  [class.legalization-odd]="isOddLegalization(row)"
                  [class.legalization-even]="isEvenLegalization(row)"
                  class="expanded-detail-row"
                ></mat-row>
              </mat-table>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>      
        <app-item-counter class="item-counter" [position]="scrollItemPosition" [length]="dataSource.count$ | async"></app-item-counter>
      </div>
    </div>
  </div>
</app-split>
